var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-table" },
    [
      _c(
        "div",
        { staticClass: "padding_50" },
        [
          _c(
            "vxe-table",
            { attrs: { data: _vm.budgetsList } },
            [
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "executeCode",
                  title: "执行编码",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "awardType",
                  title: "奖励类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.awardType === "0"
                          ? _c("span", [_vm._v("消费者开瓶")])
                          : _vm._e(),
                        row.awardType === "2"
                          ? _c("span", [_vm._v("宴席跟单奖励")])
                          : _vm._e(),
                        row.awardType === "4"
                          ? _c("span", [_vm._v("消费者买赠")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "productCode",
                  title: "产品编码",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "productName",
                  title: "产品名称",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "giftNum",
                  title: "赠酒数量（瓶）",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "actualGiftNum",
                  title: "实际赠酒数量（瓶）",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "productPrice",
                  title: "产品单价",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  "min-width": "100",
                  field: "cashAward",
                  title: "核销金额",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }